import { jsx as _jsx } from "react/jsx-runtime";
import { commandsInternal } from 'utils/commands';
/**
 * Represents the dynamically generated components that invoke the registering
 * command handlers.
 */
export const commandComponents = commandsInternal
    .map(({ name, useRegisterHandler }) => {
    if (useRegisterHandler) {
        const Component = () => {
            useRegisterHandler();
            return null;
        };
        return _jsx(Component, {}, name);
    }
})
    .filter(Boolean);
